module.exports = __webpack_public_path__ + "img/teacher-sample-m-3-vi-VN.ea5c98e1.png";